export const LOCALE_STORAGE_KEY = 'locale'
export const TUTORIAL_SEEN_KEY = 'tutorialSeen'
export const TUTORIAL_SEEN_VALUE = 'true'
